import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: 'Loading...',
};

const spinnerSlice = createSlice({
  name: 'spinner',
  initialState,
  reducers: {
    showSpinner: (state, action) => {
      state.open = true;
      // Accept either a string or an object { message }
      const p = action?.payload;
      state.message =
        typeof p === 'string'
          ? p
          : (p && typeof p.message === 'string' ? p.message : 'Loading...');
    },
    hideSpinner: (state) => {
      state.open = false;
      state.message = 'Loading...';
    },
  },
});

export const { showSpinner, hideSpinner } = spinnerSlice.actions;
export const selectSpinnerOpen = (s) => s.spinner.open;
export const selectSpinnerMessage = (s) => s.spinner.message;
export default spinnerSlice.reducer;
